import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbAlertModule, NgbDropdownModule, NgbCollapse, NgbDatepickerModule, NgbDateParserFormatter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { ComboService } from '../../../Model/Combo/combo.service';
import { CommonService } from '../../../Model/Common/common.service';
import { IncometaxService } from '../../../Model/Incometax/incometax.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { AttachmentComponent } from '../../../Component/Attachment/attachment/attachment.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-tax-investment-form',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule, NgbDropdownModule, LoaderComponent, NgbCollapse, NgbDatepickerModule, NgbAlertModule],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './tax-investment-form.component.html',
  styleUrl: './tax-investment-form.component.scss'
})
export class TaxInvestmentFormComponent {
  isDisabled: boolean = false;
  user = [] as any;
  isLoad: boolean = false;
  FinancialYears: any[] = [];
  isEditAllow = false;
  IsDraft = false;
  Message = null as any;
  ESS_EmpTaxInvestmentID = 0 as any;
  EmpMasterId = 0 as any;
  Detail = {
    SelectType: 'S',
    ESS_EmpTaxInvestmentID: 0,
    ESS_EmpTaxDeclarationID: 0,
    EmpMasterId: null as any,
    //IncomeTaxFY: null as any,
    YearStart: null as any,
    YearEnd: null as any,
    FinancialYearFrom: null as any,
    FinancialYearTo: null as any,
    IsNewRegime: false,
    IsHouseRented: false,
    IsLetOutProperty: false,
    ESS_TaxFinancialYearId: null,
    IsAdminEntry: false,
    ESS_TaxPreviousEmploymentDetails: [{
      ESS_TaxPreviousEmploymentDetailsID: 0,
      ESS_EmpTaxDeclarationID: 0,
      Monthname: null,
      Yearname: null as any,
      Remarks: null as any,
      Basic: null as any,
      DA: null as any,
      HRA: null as any,
      OtherAllowance: null as any,
      GrossAmount: 0,
      PT: null as any,
      PF: null as any,
      TDS: null as any,
      OtherDeduction: null as any,
      NetAmount: 0,
      TimeStamp: null,
      ESS_TaxSubSectionFYMasterId: null as any,
      ESS_EmpTaxInvestmentPrevEmployment_Attachment: [],
    }],
    ESS_EmpTaxInvestmentDetails: [{
      ESS_EmpTaxInvestmentDetailsId: 0,
      ESS_EmpTaxDeclarationDetailsId: 0,
      ESS_EmpTaxDeclarationID: 0,
      ESS_TaxSectionMasterId: null,
      SectionCode: null,
      SectionName: null,
      IncomeHead: null,
      SectionDescription: null,
      ESS_TaxSectionDetailId: null,
      SubSectionName: null,
      SubSectionDescription: null,
      IsNewMaxlimitapplicable: false,
      IsOldMaxlimitapplicable: false,
      NewRegimeMaxAmount: null,
      OldRegimeMaxAmount: null,
      ProofSubmissionAmount: null,
      ApprovedAmount: null,
      TimeStamp: null,
      ESS_TaxSubSectionFYMasterId: null as any,
      ESS_EmpTaxInvestmentDetails_Attachment: [],
    }],
    ESS_EmpTaxDeclarationDetails_HRA: [{
      ESS_EmpTaxDeclarationDetails_HRAID: 0,
      ESS_EmpTaxInvestmentDetails_HRAID: 0,
      ESS_EmpTaxDeclarationID: 0,
      FromDate: null as any,
      ToDate: null as any,
      NameOfLandlord: null,
      LandLordPanNo: null,
      Address: null,
      IsMetroCity: false,
      ProofSubmissionAmount: null,
      ApprovedAmount: null as any,
      TimeStamp: null,
      ESS_EmpTaxInvestmentDetails_HRAAttachment: [],
    }],
    ESS_EmpTaxDeclarationDetails_LOP: [{
      ESS_EmpTaxInvestmentDetails_LOPID: 0,
      ESS_EmpTaxDeclarationDetails_LOPID: 0,
      ESS_EmpTaxDeclarationID: 0,
      AnnualRentReceived: null as any,
      NetAnnualValue: null as any,
      StandardDeduction: null as any,
      RepayingHomeLoanForThisProperty: false,
      PrincipalPaidOnHomeLoan: null as any,
      MunicipalTaxesPaid: null as any,
      InterestPaidOnHomeLoan: null as any,
      NameOfTheLender: null,
      LenderPanNo: null,
      NetIncomeLossFromHouseProperty: null as any,
      TimeStamp: null,
      ESS_EmpTaxInvestmentDetails_LOPAttachment: []
    }],
    ESS_EmpTaxDeclarationDetails_Others: [{
      ESS_EmpTaxInvestmentDetails_OthersID: 0,
      ESS_EmpTaxDeclarationDetails_OthersID: 0,
      ESS_EmpTaxDeclarationID: 0,
      ESS_TaxSectionDetailId: null as any,
      SubSectionName: null,
      SubSectionDescription: null,
      IsNewMaxlimitapplicable: false,
      IsOldMaxlimitapplicable: false,
      NewRegimeMaxAmount: null,
      OldRegimeMaxAmount: null,
      ProofSubmissionAmount: null,
      ApprovedAmount: null,
      TimeStamp: null,
      ESS_TaxSubSectionFYMasterId: null as any,
      ESS_EmpTaxInvestmentDetails_OthersAttachment: []
    }],
  }

  SaveDetail = {
    SelectType: null as any,
    ESS_EmpTaxDeclarationId: 0,
    ESS_EmpTaxInvestmentID: 0,
    IsNewRegime: false,
    EmpMasterId: null as any,
    IsHouseRented: false,
    IsLetOutProperty: false,
    FinancialYearStart: null as any,
    FinancialYearEnd: null as any,
    ESS_TaxFinancialYearId: null,
    IsAdminEntry: false,
    ESS_TaxPreviousEmploymentDetails: [{
      Monthname: null,
      Yearname: null as any,
      Remarks: null as any,
      Basic: null as any,
      DA: null as any,
      HRA: null as any,
      OtherAllowance: null as any,
      GrossAmount: 0,
      PT: null as any,
      PF: null as any,
      TDS: null as any,
      OtherDeduction: null as any,
      NetAmount: 0,
      TimeStamp: null as any,
    }],
    ESS_EmpTaxInvestmentPrevEmployment_Attachment: [{
      Attachment: null,
      TimeStamp: null as any,
    }],
    ESS_EmpTaxInvestmentDetails: [{
      ESS_TaxSectionDetailId: 0,
      ESS_TaxSubSectionFYMasterId: null as any,
      Amount: 0,
      TimeStamp: null as any,
    }],
    ESS_EmpTaxInvestmentDetails_Attachment: [{
      Attachment: null,
      TimeStamp: null as any,
    }],
    ESS_EmpTaxInvestmentDetails_HRA: [{
      FromDate: null as any,
      ToDate: null as any,
      NameOfLandlord: null,
      LandLordPanNo: null,
      Address: null,
      IsMetroCity: false,
      Amount: null,
      TimeStamp: null as any,
    }],
    ESS_EmpTaxInvestmentDetails_HRAAttachment: [{
      Attachment: null,
      TimeStamp: null as any,
    }],
    ESS_EmpTaxInvestmentDetails_LOP: [{
      AnnualRentReceived: null as any,
      NetAnnualValue: null as any,
      StandardDeduction: null as any,
      RepayingHomeLoanForThisProperty: false,
      PrincipalPaidOnHomeLoan: null as any,
      MunicipalTaxesPaid: null as any,
      InterestPaidOnHomeLoan: null as any,
      NameOfTheLender: null,
      LenderPanNo: null,
      NetIncomeLossFromHouseProperty: null as any,
      TimeStamp: null as any,
    }],
    ESS_EmpTaxInvestmentDetails_LOPAttachment: [{
      Attachment: null,
      TimeStamp: null as any,
    }],
    ESS_EmpTaxInvestmentDetails_Others: [{
      ESS_TaxSectionDetailId: null as any,
      ESS_TaxSubSectionFYMasterId: null as any,
      Amount: null,
      TimeStamp: null as any,
    }],
    ESS_EmpTaxInvestmentDetails_OthersAttachment: [{
      Attachment: null,
      TimeStamp: null as any,
    }],
  }

  OpenCard = {
    CardPreviousEmployment: false as any,
    CardEmpTaxDeclarationDetails: false as any,
    CardEmpTaxDeclarationDetails_HRA: false as any,
    CardEmpTaxDeclarationDetails_Others: false as any,
    CardEmpTaxDeclarationDetails_LOP: false as any,
  }

  UserDetails = {
    EmpMasterID: null,
    EmpCode: null,
    Name: null as any,
    Designation: null,
    Photo: null as any,
  }

  MinDate = null as any;
  MaxDate = null as any;
  SectionDetails = [] as any;
  SectionDetailsOther = [] as any;
  Sections = [] as any;
  SectionsOther = [] as any;
  filteredSectionMap: { [key: number]: any[] } = {};

  type = null;

  constructor(
    private toast: ToastService,
    private modalService: NgbModal,
    protected common: CommonService,
    private tooltip: TooltipService,
    private incometax: IncometaxService,
    private combo: ComboService,
    protected dateFormat: CustomDateParserFormatter,
    private router: Router,
    private session: SessionService,
    private route: ActivatedRoute,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    if (this.user.UserType == 'A') {
      this.route.params.subscribe(params => params['type'] == 'r' ? this.Detail.ESS_EmpTaxInvestmentID = parseInt(params['empid']) : this.Detail.EmpMasterId = parseInt(params['empid']));
    } else {
      this.route.params.subscribe(params => this.Detail.ESS_EmpTaxInvestmentID = parseInt(params['id']));
    }
    //this.route.params.subscribe(params => this.IsDraft = params['draft']);
  }

  ngOnInit(): void {
    this.ESS_EmpTaxInvestmentID = this.Detail.ESS_EmpTaxInvestmentID;
    this.EmpMasterId = this.Detail.EmpMasterId;

    if (this.user.UserType == 'A') {
      this.Detail.IsAdminEntry = true;
      if (this.Detail.EmpMasterId > 0) {
        this.ComboLoad("FilterOnEmpCodeName");
      }
    }
    this.ESS_TaxFinancialYearSelect();
  }

  Validate(form: any) {
    if (form.valid) {
      if ((this.common.PageRight.IsAdd && this.Detail.ESS_EmpTaxInvestmentID == 0) || (this.common.PageRight.IsEdit && this.Detail.ESS_EmpTaxInvestmentID > 0)) {
        if (this.isEditAllow) {
          if (this.user.UserType == 'E' && this.Detail.ESS_EmpTaxInvestmentID > 0) {
            this.SaveDetail.SelectType = 'Update';
          } else {
            this.SaveDetail.SelectType = 'Insert';
          }

          this.SaveDetail.ESS_EmpTaxDeclarationId = this.Detail.ESS_EmpTaxDeclarationID;
          this.SaveDetail.ESS_EmpTaxInvestmentID = this.Detail.ESS_EmpTaxInvestmentID;
          this.SaveDetail.IsNewRegime = this.Detail.IsNewRegime;

          if (this.user.UserType == 'E') {
            this.SaveDetail.EmpMasterId = this.user.UserId;
          } else {
            this.SaveDetail.EmpMasterId = this.Detail.EmpMasterId;
          }

          this.SaveDetail.IsHouseRented = this.Detail.IsHouseRented;
          this.SaveDetail.IsLetOutProperty = this.Detail.IsLetOutProperty;
          this.SaveDetail.FinancialYearStart = this.Detail.FinancialYearFrom;
          this.SaveDetail.FinancialYearEnd = this.Detail.FinancialYearTo;
          this.SaveDetail.ESS_TaxFinancialYearId = this.Detail.ESS_TaxFinancialYearId;
          this.SaveDetail.IsAdminEntry = this.Detail.IsAdminEntry;

          this.SaveDetail.ESS_TaxPreviousEmploymentDetails = [];
          this.SaveDetail.ESS_EmpTaxInvestmentPrevEmployment_Attachment = [];

          this.Detail.ESS_TaxPreviousEmploymentDetails.forEach((element, index) => {
            var timestmp = Date.now().toString() + '1' + index.toString();

            this.SaveDetail.ESS_TaxPreviousEmploymentDetails.push({
              Monthname: element.Monthname,
              Yearname: element.Yearname,
              Remarks: element.Remarks,
              Basic: element.Basic,
              DA: element.DA,
              HRA: element.HRA,
              OtherAllowance: element.OtherAllowance,
              GrossAmount: element.GrossAmount,
              PT: element.PT,
              PF: element.PF,
              TDS: element.TDS,
              OtherDeduction: element.OtherDeduction,
              NetAmount: element.NetAmount,
              TimeStamp: timestmp,
            });

            element.ESS_EmpTaxInvestmentPrevEmployment_Attachment.forEach(elementAtt => {
              this.SaveDetail.ESS_EmpTaxInvestmentPrevEmployment_Attachment.push({
                Attachment: elementAtt['Attachment'],
                TimeStamp: timestmp,
              })
            });
          });

          this.SaveDetail.ESS_EmpTaxInvestmentDetails = [];
          this.SaveDetail.ESS_EmpTaxInvestmentDetails_Attachment = [];

          this.SectionDetails.filter((e: any) => e.IsAdded).forEach((element: any, index: any) => {
            var timestmp = Date.now().toString() + '2' + index.toString();

            this.SaveDetail.ESS_EmpTaxInvestmentDetails.push({
              ESS_TaxSectionDetailId: element.ESS_TaxSubSectionFYMasterID,
              ESS_TaxSubSectionFYMasterId: element.ESS_TaxSubSectionFYMasterID,
              Amount: element.ProofSubmissionAmount,
              TimeStamp: timestmp,
            });

            element.Attachments.forEach((elementAtt: any) => {
              this.SaveDetail.ESS_EmpTaxInvestmentDetails_Attachment.push({
                Attachment: elementAtt['Attachment'],
                TimeStamp: timestmp,
              });
            });
          });

          this.SaveDetail.ESS_EmpTaxInvestmentDetails_HRA = [];
          this.SaveDetail.ESS_EmpTaxInvestmentDetails_HRAAttachment = [];

          this.Detail.ESS_EmpTaxDeclarationDetails_HRA.forEach((element, index) => {
            var timestmp = Date.now().toString() + '3' + index.toString();

            this.SaveDetail.ESS_EmpTaxInvestmentDetails_HRA.push({
              FromDate: (element.FromDate != "" && element.FromDate != null) ? this.dateFormat.format(element.FromDate) : '',
              ToDate: (element.ToDate != "" && element.ToDate != null) ? this.dateFormat.format(element.ToDate) : '',
              NameOfLandlord: element.NameOfLandlord,
              LandLordPanNo: element.LandLordPanNo,
              Address: element.Address,
              IsMetroCity: element.IsMetroCity,
              Amount: element.ProofSubmissionAmount,
              TimeStamp: timestmp,
            });

            element.ESS_EmpTaxInvestmentDetails_HRAAttachment.forEach(elementAtt => {
              this.SaveDetail.ESS_EmpTaxInvestmentDetails_HRAAttachment.push({
                Attachment: elementAtt['Attachment'],
                TimeStamp: timestmp,
              })
            });
          });

          this.SaveDetail.ESS_EmpTaxInvestmentDetails_LOP = [];
          this.SaveDetail.ESS_EmpTaxInvestmentDetails_LOPAttachment = [];

          this.Detail.ESS_EmpTaxDeclarationDetails_LOP.forEach((element, index) => {
            var timestmp = Date.now().toString() + '4' + index.toString();

            this.SaveDetail.ESS_EmpTaxInvestmentDetails_LOP.push({
              AnnualRentReceived: element.AnnualRentReceived,
              NetAnnualValue: element.NetAnnualValue,
              StandardDeduction: element.StandardDeduction,
              RepayingHomeLoanForThisProperty: element.RepayingHomeLoanForThisProperty,
              PrincipalPaidOnHomeLoan: element.PrincipalPaidOnHomeLoan,
              MunicipalTaxesPaid: element.MunicipalTaxesPaid,
              InterestPaidOnHomeLoan: element.InterestPaidOnHomeLoan,
              NameOfTheLender: element.NameOfTheLender,
              LenderPanNo: element.LenderPanNo,
              NetIncomeLossFromHouseProperty: element.NetIncomeLossFromHouseProperty,
              TimeStamp: timestmp,
            });

            element.ESS_EmpTaxInvestmentDetails_LOPAttachment.forEach(elementAtt => {
              this.SaveDetail.ESS_EmpTaxInvestmentDetails_LOPAttachment.push({
                Attachment: elementAtt['Attachment'],
                TimeStamp: timestmp,
              })
            });
          });

          this.SaveDetail.ESS_EmpTaxInvestmentDetails_Others = [];
          this.SaveDetail.ESS_EmpTaxInvestmentDetails_OthersAttachment = [];

          this.SectionDetailsOther.filter((e: any) => e.IsAdded).forEach((element: any, index: any) => {
            var timestmp = Date.now().toString() + '5' + index.toString();

            this.SaveDetail.ESS_EmpTaxInvestmentDetails_Others.push({
              ESS_TaxSectionDetailId: element.ESS_TaxSubSectionFYMasterID,
              ESS_TaxSubSectionFYMasterId: element.ESS_TaxSubSectionFYMasterID,
              Amount: element.ProofSubmissionAmount,
              TimeStamp: timestmp,
            });

            element.Attachments.forEach((elementAtt: any) => {
              this.SaveDetail.ESS_EmpTaxInvestmentDetails_OthersAttachment.push({
                Attachment: elementAtt['Attachment'],
                TimeStamp: timestmp,
              });
            });
          });
          this.ESS_EmpTaxInvestment_InsertUpdate();
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    } else {
      this.toast.show({ message: 'Please fill mandatory fields', type: toastTypeEnum.danger });
      form.submitted = true;
    }
  }

  ESS_EmpTaxInvestmentSelect() {
    this.Message = null;
    if (this.Detail.ESS_TaxFinancialYearId != null && this.Detail.ESS_TaxFinancialYearId != '' && this.Detail.ESS_TaxFinancialYearId > 0) {
      this.isDisabled = true;
      this.Detail.FinancialYearFrom = this.dateFormat.format({ day: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].FinancialYearStart).getDate(), month: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].FinancialYearStart).getMonth() + 1, year: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].FinancialYearStart).getFullYear() });
      this.Detail.FinancialYearTo = this.dateFormat.format({ day: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].FinancialYearEnd).getDate(), month: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].FinancialYearEnd).getMonth() + 1, year: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].FinancialYearEnd).getFullYear() });

      this.MinDate = this.dateFormat.parse(this.Detail.FinancialYearFrom);
      this.MaxDate = this.dateFormat.parse(this.Detail.FinancialYearTo);

      if (this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].IsInvestmentOpen == 0) {
        this.Message = 'The investment has been locked, and Add/Edit is not allowed. kindly contact administrator';
        this.isEditAllow = false;
      }

      this.ESS_EmpTaxInvestmentSelectGet('S');

      // this.incometax.ESS_EmpTaxInvestmentSelect(this.Detail).subscribe({
      //   next: (response) => {
      //     if (response) {
      //       if (response.Table && response.Table.length > 0) {
      //         this.Detail.ESS_EmpTaxDeclarationID = response.Table[0].ESS_EmpTaxDeclarationID;
      //         this.Detail.IsNewRegime = response.Table[0].IsNewRegime;
      //         this.Detail.EmpMasterId = response.Table[0].EmpMasterId;
      //         this.Detail.FinancialYearFrom = response.Table[0].FinancialYearStart;
      //         this.Detail.FinancialYearTo = response.Table[0].FinancialYearEnd;
      //         this.isEditAllow = this.common.ToLowerCase(response.Table[0].ApprovalStatus) == 'approved';


      //         if (response.Table1) {
      //           this.Detail.ESS_EmpTaxInvestmentDetails = response.Table1.map((e: any) => ({ ...e, ESS_EmpTaxInvestmentDetails_Attachment: [] }));
      //         }

      //         if (response.Table2) {
      //           if (response.Table2[0].ESS_EmpTaxDeclarationDetailsId > 0) {
      //             //this.Detail.ESS_EmpTaxInvestmentDetails_Attachment = response.Table2
      //           }
      //         }

      //         if (response.Table3) {
      //           this.Detail.ESS_TaxPreviousEmploymentDetails = response.Table3.map((e: any) => ({ ...e, ESS_EmpTaxInvestmentPrevEmployment_Attachment: [] }));
      //         }

      //         if (response.Table4) {
      //           if (response.Table4[0].ESS_TaxPreviousEmploymentDetailsID > 0) {
      //             //this.Detail.ESS_EmpTaxInvestmentPrevEmployment_Attachment = response.Table4
      //           }
      //         }

      //         if (response.Table5) {
      //           this.Detail.ESS_EmpTaxDeclarationDetails_HRA = response.Table5.map((e: any) => ({ ...e, ESS_EmpTaxInvestmentDetails_HRAAttachment: [] }));
      //           this.Detail.ESS_EmpTaxDeclarationDetails_HRA.forEach(element => {
      //             if (element.FromDate != null && element.FromDate != '') {
      //               element.FromDate = this.dateFormat.parse(element.FromDate);
      //             }
      //             if (element.ToDate != null && element.ToDate != '') {
      //               element.ToDate = this.dateFormat.parse(element.ToDate);
      //             }
      //           });
      //           this.Detail.IsHouseRented = true;
      //           //Table6 attachment
      //         }

      //         if (response.Table7) {
      //           this.Detail.ESS_EmpTaxDeclarationDetails_Others = response.Table7;
      //           //Table8 attachment
      //         }

      //         if (response.Table9) {
      //           this.Detail.ESS_EmpTaxDeclarationDetails_LOP = response.Table9.map((e: any) => ({ ...e, ESS_EmpTaxInvestmentDetails_LOPAttachment: [] }));;
      //           this.Detail.IsLetOutProperty = true;
      //           //Table10 attachment
      //         }

      //         this.TaxSectionMasterSelectLoad();
      //         this.ComboLoad('IncomeTaxHead');
      //         this.isLoad = true;
      //         this.OpenCard = {
      //           CardPreviousEmployment: true as any,
      //           CardEmpTaxDeclarationDetails: true as any,
      //           CardEmpTaxDeclarationDetails_HRA: true as any,
      //           CardEmpTaxDeclarationDetails_Others: true as any,
      //           CardEmpTaxDeclarationDetails_LOP: true as any,
      //         }

      //         if (this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].IsInvestmentOpen == 0
      //           || (!this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].IsMultipleProofSubmissionAllowed && response.Table[0].ESS_EmpTaxInvestmentID > 0)) {
      //           this.isEditAllow = false;
      //           if (this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].IsInvestmentOpen == 0) {
      //             this.Message = 'The investment has been locked, and Add/Edit is not allowed. kindly contact administrator';
      //           }
      //         }

      //       } else {
      //         this.isLoad = true;
      //         this.OpenCard = {
      //           CardPreviousEmployment: true as any,
      //           CardEmpTaxDeclarationDetails: true as any,
      //           CardEmpTaxDeclarationDetails_HRA: true as any,
      //           CardEmpTaxDeclarationDetails_Others: true as any,
      //           CardEmpTaxDeclarationDetails_LOP: true as any,
      //         }
      //         this.TaxSectionMasterSelectLoad();
      //         this.ComboLoad('IncomeTaxHead');
      //         if (this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].IsInvestmentOpen == 1) {
      //           this.isEditAllow = true;
      //         } else {
      //           this.isEditAllow = false;
      //         }
      //       }
      //     }
      //     this.isDisabled = false;
      //   },
      //   complete: () => {
      //   },
      //   error: (error) => {
      //     this.isDisabled = false;
      //   },
      // });
    } else {
      this.toast.show({ message: "Please financial year", type: toastTypeEnum.danger });
    }
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.combo.ComboLoad({ 'Combotype': Combotype, 'EmpMasterID': Combotype == 'FilterOnEmpCodeName' ? this.Detail.EmpMasterId : this.user.UserId }).subscribe({
      next: (response) => {
        if (Combotype == 'IncomeTaxHead') {
          response.ComboLoad.forEach((element: any) => {
            this.TaxSectionDetail_SelectLoad(element)
          });
        } else if (Combotype == 'FilterOnEmpCodeName') {
          this.UserDetails = response.ComboLoad[0];
        }
        this.isDisabled = false;
      },
      complete: () => {
        // if (this.Detail.ESS_EmpTaxInvestmentID > 0) {
        //   if (Combotype == 'IncomeTax_FinancialYear') {
        //     this.ESS_EmpTaxInvestmentSelectGet();
        //   }
        // } else {
        //   this.isEditAllow = true;
        // }
        // if (this.Detail.ESS_EmpTaxInvestmentID == 0) {
        //   this.isEditAllow = true;
        // }
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  filterSubSection(sectionid: number, IsDefaultSubSection: any, IsDefaultSubSectionCheck: boolean, IsFromOther: boolean): [] {
    if (IsDefaultSubSectionCheck) {
      if (!IsFromOther) {
        return this.SectionDetails.filter((e: any) => e.ESS_TaxSectionMasterId == sectionid && (IsDefaultSubSection == null || e.IsAdded == IsDefaultSubSection));
      } else {
        return this.SectionDetailsOther.filter((e: any) => e.ESS_TaxSectionMasterId == sectionid && (IsDefaultSubSection == null || e.IsAdded == IsDefaultSubSection));
      }
    } else {
      if (!IsFromOther) {
        return this.SectionDetails.filter((e: any) => e.ESS_TaxSectionMasterId == sectionid);
      } else {
        return this.SectionDetailsOther.filter((e: any) => e.ESS_TaxSectionMasterId == sectionid);
      }
    }
  }

  updateFilteredSections() {
    this.filteredSectionMap = {};

    this.SectionDetails.forEach((item: any) => {
      const key = item.ESS_TaxSectionMasterId;
      if (!this.filteredSectionMap[key]) {
        this.filteredSectionMap[key] = [];
      }

      if (item.IsAdded) {
        this.filteredSectionMap[key].push(item);
      }
    });
  }

  TaxSectionMasterSelectLoad() {
    this.isDisabled = true;
    this.incometax.TaxSectionMasterSelectLoad({ SelectType: 'S', ESS_TaxSectionMasterID: 0, FinancialYearFrom: this.Detail.FinancialYearFrom, FinancialYearTo: this.Detail.FinancialYearTo }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.Sections = response.Table.map((e: any) => ({ ...e, ESS_TaxSectionMasterIDSelected: null }));
          this.SectionsOther = response.Table.map((e: any) => ({ ...e, ESS_TaxSectionMasterIDSelected: null }));
        } else {
          this.Sections = [];
          this.SectionsOther = [];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  TaxSectionDetail_SelectLoad(IncomeHead: any) {
    this.isDisabled = true;
    this.incometax.TaxSectionDetail_SelectLoad({ SelectType: 'S', ESS_TaxSectionDetailID: 0, ESS_TaxSectionMasterID: 0, FinancialYearFrom: this.Detail.FinancialYearFrom, FinancialYearTo: this.Detail.FinancialYearTo, IsNewRegime: this.Detail.IsNewRegime, IncomeHead: IncomeHead.value }).subscribe({
      next: (response) => {
        if (response.Table) {
          if (this.common.ToLowerCase(IncomeHead.Name) == 'income from salary') {
            this.SectionDetails = response.Table.map((e: any, i: number) => ({ ...e, IsAdded: e.IsDefaultSubSection, ProofSubmissionAmount: 0, Index: i, Attachments: [] as any }));
            this.Detail.ESS_EmpTaxInvestmentDetails.forEach(element => {
              if (element.ESS_TaxSubSectionFYMasterId != null && element.ESS_TaxSubSectionFYMasterId != '' && element.ESS_TaxSubSectionFYMasterId > 0) {
                this.SectionDetails[this.SectionDetails.findIndex((e: any) => e.ESS_TaxSubSectionFYMasterID == element.ESS_TaxSubSectionFYMasterId)].IsAdded = true;
                this.SectionDetails[this.SectionDetails.findIndex((e: any) => e.ESS_TaxSubSectionFYMasterID == element.ESS_TaxSubSectionFYMasterId)].IsDefaultSubSection = true;
                this.SectionDetails[this.SectionDetails.findIndex((e: any) => e.ESS_TaxSubSectionFYMasterID == element.ESS_TaxSubSectionFYMasterId)].ApprovedAmount = element.ApprovedAmount;
                this.SectionDetails[this.SectionDetails.findIndex((e: any) => e.ESS_TaxSubSectionFYMasterID == element.ESS_TaxSubSectionFYMasterId)].ProofSubmissionAmount = element.ProofSubmissionAmount;
                if (element.ESS_EmpTaxInvestmentDetails_Attachment.length > 0) {
                  this.SectionDetails[this.SectionDetails.findIndex((e: any) => e.ESS_TaxSubSectionFYMasterID == element.ESS_TaxSubSectionFYMasterId)].Attachments = element.ESS_EmpTaxInvestmentDetails_Attachment.map((e: any) => ({ 'Attachment': e.Attachment }))
                }
              }
            });
          } else if (this.common.ToLowerCase(IncomeHead.Name) == 'income from other sources') {
            this.SectionDetailsOther = response.Table.map((e: any, i: number) => ({ ...e, IsAdded: e.IsDefaultSubSection, ProofSubmissionAmount: 0, Index: i, Attachments: [] }));
            this.Detail.ESS_EmpTaxDeclarationDetails_Others.forEach(element => {
              if (element.ESS_TaxSubSectionFYMasterId != null && element.ESS_TaxSubSectionFYMasterId != '' && element.ESS_TaxSubSectionFYMasterId > 0) {
                this.SectionDetailsOther[this.SectionDetailsOther.findIndex((e: any) => e.ESS_TaxSubSectionFYMasterID == element.ESS_TaxSubSectionFYMasterId)].IsAdded = true;
                this.SectionDetailsOther[this.SectionDetailsOther.findIndex((e: any) => e.ESS_TaxSubSectionFYMasterID == element.ESS_TaxSubSectionFYMasterId)].IsDefaultSubSection = true;
                this.SectionDetailsOther[this.SectionDetailsOther.findIndex((e: any) => e.ESS_TaxSubSectionFYMasterID == element.ESS_TaxSubSectionFYMasterId)].ApprovedAmount = element.ApprovedAmount;
                this.SectionDetailsOther[this.SectionDetailsOther.findIndex((e: any) => e.ESS_TaxSubSectionFYMasterID == element.ESS_TaxSubSectionFYMasterId)].ProofSubmissionAmount = element.ProofSubmissionAmount;
                if (element.ESS_EmpTaxInvestmentDetails_OthersAttachment.length > 0) {
                  this.SectionDetailsOther[this.SectionDetailsOther.findIndex((e: any) => e.ESS_TaxSubSectionFYMasterID == element.ESS_TaxSubSectionFYMasterId)].Attachments = element.ESS_EmpTaxInvestmentDetails_OthersAttachment.map((e: any) => ({ 'Attachment': e.Attachment }))
                }
              }
            });
          }
        } else {
          this.SectionDetails = [];
          this.SectionDetailsOther = [];
        }
        this.updateFilteredSections();
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Add(cardname: string, index = 0) {
    if (cardname == "CardPreviousEmployment") {
      this.Detail.ESS_TaxPreviousEmploymentDetails.push(
        {
          ESS_TaxPreviousEmploymentDetailsID: 0,
          ESS_EmpTaxDeclarationID: 0,
          Monthname: null,
          Yearname: null as any,
          Basic: null as any,
          DA: null as any,
          HRA: null as any,
          OtherAllowance: null as any,
          GrossAmount: 0,
          PT: null as any,
          PF: null as any,
          TDS: null as any,
          OtherDeduction: null as any,
          NetAmount: 0,
          TimeStamp: null,
          Remarks: null,
          ESS_TaxSubSectionFYMasterId: null as any,
          ESS_EmpTaxInvestmentPrevEmployment_Attachment: []
        }
      );
    } else if (cardname == "CardEmpTaxDeclarationDetails") {
      this.SectionDetails[this.SectionDetails.findIndex((e: any) => e.ESS_TaxSectionDetailID == this.Sections[index].ESS_TaxSectionMasterIDSelected)].IsAdded = true;
      this.Sections[index].ESS_TaxSectionMasterIDSelected = null;
      //this.updateFilteredSections();
      // debugger;
      // this.filteredSectionMap[this.Sections[index].ESS_TaxSectionMasterID].push(this.SectionDetails[this.SectionDetails.findIndex((e: any) => e.ESS_TaxSectionDetailID == this.Sections[index].ESS_TaxSectionMasterIDSelected)]);
      // debugger;
      // const selectedId = this.Sections[index].ESS_TaxSectionMasterIDSelected;

      // const detailIndex = this.SectionDetails.findIndex((e:any) => e.ESS_TaxSectionDetailID === selectedId);

      // if (detailIndex !== -1) {
      //   this.SectionDetails[detailIndex] = {
      //     ...this.SectionDetails[detailIndex],
      //     IsAdded: true,
      //     ProofSubmissionAmount: 0 // optional default
      //   };
      //   this.Sections[index].ESS_TaxSectionMasterIDSelected = null;
      //   this.updateFilteredSections();
      // }

    } else if (cardname == "CardEmpTaxDeclarationDetails_HRA") {
      this.Detail.ESS_EmpTaxDeclarationDetails_HRA.push(
        {
          ESS_EmpTaxDeclarationDetails_HRAID: 0,
          ESS_EmpTaxInvestmentDetails_HRAID: 0,
          ESS_EmpTaxDeclarationID: 0,
          FromDate: null as any,
          ToDate: null as any,
          NameOfLandlord: null,
          LandLordPanNo: null,
          Address: null,
          IsMetroCity: false,
          ProofSubmissionAmount: null,
          ApprovedAmount: null as any,
          TimeStamp: null,
          ESS_EmpTaxInvestmentDetails_HRAAttachment: []
        });
    } else if (cardname == "CardEmpTaxDeclarationDetails_Others") {
      this.SectionDetailsOther[this.SectionDetailsOther.findIndex((e: any) => e.ESS_TaxSectionDetailID == this.SectionsOther[index].ESS_TaxSectionMasterIDSelected)].IsAdded = true;
      this.SectionsOther[index].ESS_TaxSectionMasterIDSelected = null;
    } else if (cardname == "CardEmpTaxDeclarationDetails_LOP") {
      this.Detail.ESS_EmpTaxDeclarationDetails_LOP.push(
        {
          ESS_EmpTaxInvestmentDetails_LOPID: 0,
          ESS_EmpTaxDeclarationDetails_LOPID: 0,
          ESS_EmpTaxDeclarationID: 0,
          AnnualRentReceived: null,
          NetAnnualValue: null,
          StandardDeduction: null,
          RepayingHomeLoanForThisProperty: false,
          PrincipalPaidOnHomeLoan: null,
          MunicipalTaxesPaid: null,
          InterestPaidOnHomeLoan: null,
          NameOfTheLender: null,
          LenderPanNo: null,
          NetIncomeLossFromHouseProperty: null,
          TimeStamp: null,
          ESS_EmpTaxInvestmentDetails_LOPAttachment: []
        });
    }
  }

  Delete(i: number, cardname: string) {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Do you want to delete?';
    modalRef.result.then((result: any) => {
      if (result) {
        if (cardname == "CardPreviousEmployment") {
          this.Detail.ESS_TaxPreviousEmploymentDetails.splice(i, 1);
        } else if (cardname == "CardEmpTaxDeclarationDetails") {
          this.SectionDetails[this.SectionDetails.findIndex((e: any) => e.ESS_TaxSectionDetailID == i)].IsAdded = false;
        } else if (cardname == "CardEmpTaxDeclarationDetails_HRA") {
          this.Detail.ESS_EmpTaxDeclarationDetails_HRA.splice(i, 1);
        } else if (cardname == "CardEmpTaxDeclarationDetails_Others") {
          this.SectionDetailsOther[this.SectionDetailsOther.findIndex((e: any) => e.ESS_TaxSectionDetailID == i)].IsAdded = false;
        } else if (cardname == "CardEmpTaxDeclarationDetails_LOP") {
          this.Detail.ESS_EmpTaxDeclarationDetails_LOP.splice(i, 1);
        }
      }
    });
  }

  // setYear(event: any, i: number, element: any) {
  //   if (this.Detail.ESS_TaxPreviousEmploymentDetails.filter(e => e.Monthname == event.Name && e.Yearname != null && e.Yearname != '').length == 0) {
  //     if (event.IsEndFinYear) {
  //       if (this.Detail.IncomeTaxFY != null && this.Detail.IncomeTaxFY != '') {
  //         this.Detail.ESS_TaxPreviousEmploymentDetails[i].Yearname = new Date(this.IncomeTax_FinancialYear.filter((e: any) => e.IncomeTaxFY == this.Detail.IncomeTaxFY)[0]['FinancialYearEnd']).getFullYear();
  //       }
  //     } else {
  //       if (this.Detail.IncomeTaxFY != null && this.Detail.IncomeTaxFY != '') {
  //         this.Detail.ESS_TaxPreviousEmploymentDetails[i].Yearname = new Date(this.IncomeTax_FinancialYear.filter((e: any) => e.IncomeTaxFY == this.Detail.IncomeTaxFY)[0]['FinancialYearStart']).getFullYear();
  //       }
  //     }
  //   } else {
  //     element.Monthname = null;
  //     element.Yearname = null;
  //     this.toast.show({ message: "Month already selected", type: toastTypeEnum.dark });
  //   }
  // }

  CalcGross(index: number) {
    this.Detail.ESS_TaxPreviousEmploymentDetails[index].GrossAmount = 0;
    this.Detail.ESS_TaxPreviousEmploymentDetails[index].NetAmount = 0;

    if (this.Detail.ESS_TaxPreviousEmploymentDetails[index].Basic != null && this.Detail.ESS_TaxPreviousEmploymentDetails[index].Basic != '' && this.Detail.ESS_TaxPreviousEmploymentDetails[index].Basic > 0) {
      this.Detail.ESS_TaxPreviousEmploymentDetails[index].GrossAmount += parseFloat(this.Detail.ESS_TaxPreviousEmploymentDetails[index].Basic);
    }
    if (this.Detail.ESS_TaxPreviousEmploymentDetails[index].DA != null && this.Detail.ESS_TaxPreviousEmploymentDetails[index].DA != '' && this.Detail.ESS_TaxPreviousEmploymentDetails[index].DA > 0) {
      this.Detail.ESS_TaxPreviousEmploymentDetails[index].GrossAmount += parseFloat(this.Detail.ESS_TaxPreviousEmploymentDetails[index].DA);
    }
    if (this.Detail.ESS_TaxPreviousEmploymentDetails[index].HRA != null && this.Detail.ESS_TaxPreviousEmploymentDetails[index].HRA != '' && this.Detail.ESS_TaxPreviousEmploymentDetails[index].HRA > 0) {
      this.Detail.ESS_TaxPreviousEmploymentDetails[index].GrossAmount += parseFloat(this.Detail.ESS_TaxPreviousEmploymentDetails[index].HRA);
    }
    if (this.Detail.ESS_TaxPreviousEmploymentDetails[index].OtherAllowance != null && this.Detail.ESS_TaxPreviousEmploymentDetails[index].OtherAllowance != '' && this.Detail.ESS_TaxPreviousEmploymentDetails[index].OtherAllowance > 0) {
      this.Detail.ESS_TaxPreviousEmploymentDetails[index].GrossAmount += parseFloat(this.Detail.ESS_TaxPreviousEmploymentDetails[index].OtherAllowance);
    }
    if (this.Detail.ESS_TaxPreviousEmploymentDetails[index].OtherAllowance != null && this.Detail.ESS_TaxPreviousEmploymentDetails[index].OtherAllowance != '' && this.Detail.ESS_TaxPreviousEmploymentDetails[index].OtherAllowance > 0) {
      this.Detail.ESS_TaxPreviousEmploymentDetails[index].GrossAmount += parseFloat(this.Detail.ESS_TaxPreviousEmploymentDetails[index].OtherAllowance);
    }

    if (this.Detail.ESS_TaxPreviousEmploymentDetails[index].PT != null && this.Detail.ESS_TaxPreviousEmploymentDetails[index].PT != '' && this.Detail.ESS_TaxPreviousEmploymentDetails[index].PT > 0) {
      this.Detail.ESS_TaxPreviousEmploymentDetails[index].NetAmount += parseFloat(this.Detail.ESS_TaxPreviousEmploymentDetails[index].PT);
    }
    if (this.Detail.ESS_TaxPreviousEmploymentDetails[index].PF != null && this.Detail.ESS_TaxPreviousEmploymentDetails[index].PF != '' && this.Detail.ESS_TaxPreviousEmploymentDetails[index].PF > 0) {
      this.Detail.ESS_TaxPreviousEmploymentDetails[index].NetAmount += parseFloat(this.Detail.ESS_TaxPreviousEmploymentDetails[index].PF);
    }
    if (this.Detail.ESS_TaxPreviousEmploymentDetails[index].TDS != null && this.Detail.ESS_TaxPreviousEmploymentDetails[index].TDS != '' && this.Detail.ESS_TaxPreviousEmploymentDetails[index].TDS > 0) {
      this.Detail.ESS_TaxPreviousEmploymentDetails[index].NetAmount += parseFloat(this.Detail.ESS_TaxPreviousEmploymentDetails[index].TDS);
    }
    if (this.Detail.ESS_TaxPreviousEmploymentDetails[index].OtherDeduction != null && this.Detail.ESS_TaxPreviousEmploymentDetails[index].OtherDeduction != '' && this.Detail.ESS_TaxPreviousEmploymentDetails[index].OtherDeduction > 0) {
      this.Detail.ESS_TaxPreviousEmploymentDetails[index].NetAmount += parseFloat(this.Detail.ESS_TaxPreviousEmploymentDetails[index].OtherDeduction);
    }

    this.Detail.ESS_TaxPreviousEmploymentDetails[index].NetAmount = this.Detail.ESS_TaxPreviousEmploymentDetails[index].GrossAmount - this.Detail.ESS_TaxPreviousEmploymentDetails[index].NetAmount;
  }

  CalcNet(index: number) {
    this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetAnnualValue = 0;
    this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].StandardDeduction = 0;
    this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetIncomeLossFromHouseProperty = 0;

    if (this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].AnnualRentReceived != null && this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].AnnualRentReceived != '' && this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].AnnualRentReceived > 0) {
      this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetAnnualValue += parseFloat(this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].AnnualRentReceived);
    }
    if (this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].MunicipalTaxesPaid != null && this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].MunicipalTaxesPaid != '' && this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].MunicipalTaxesPaid > 0) {
      this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetAnnualValue -= parseFloat(this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].MunicipalTaxesPaid);
    }

    this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetIncomeLossFromHouseProperty = parseFloat(this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetAnnualValue);

    if (this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetAnnualValue != null && this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetAnnualValue != '' && this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetAnnualValue > 0) {
      this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].StandardDeduction = (parseFloat(this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetAnnualValue) * 30) / 100;
      this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetIncomeLossFromHouseProperty = parseFloat(this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetIncomeLossFromHouseProperty) - parseFloat(this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].StandardDeduction);
    }

    if (this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].RepayingHomeLoanForThisProperty) {
      if (this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].PrincipalPaidOnHomeLoan != null && this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].PrincipalPaidOnHomeLoan != '' && this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].PrincipalPaidOnHomeLoan > 0) {
        this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetIncomeLossFromHouseProperty = parseFloat(this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetIncomeLossFromHouseProperty) - parseFloat(this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].PrincipalPaidOnHomeLoan);
      }
      if (this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].InterestPaidOnHomeLoan != null && this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].InterestPaidOnHomeLoan != '' && this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].InterestPaidOnHomeLoan > 0) {
        this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetIncomeLossFromHouseProperty = parseFloat(this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].NetIncomeLossFromHouseProperty) - parseFloat(this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].InterestPaidOnHomeLoan);
      }
    }
  }

  Reset() {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Do you want to reset?';
    modalRef.componentInstance.Message2 = 'All data will reset!';
    modalRef.result.then((result: any) => {
      if (result) {
        this.isLoad = false;
        this.Message = null;
        this.OpenCard = {
          CardPreviousEmployment: false as any,
          CardEmpTaxDeclarationDetails: false as any,
          CardEmpTaxDeclarationDetails_HRA: false as any,
          CardEmpTaxDeclarationDetails_Others: false as any,
          CardEmpTaxDeclarationDetails_LOP: false as any,
        }
      }
    });
  }

  Cancel() {
    if (this.user.UserType == 'A') {
      this.router.navigate(['/incometax/incometax/']);
    } else {
      this.router.navigate(['/request/incometax/taxinvestment/']);
    }
  }

  trackByIndex(index: number, item: any): number {
    return item.ESS_TaxSectionDetailID;
  }

  attachmentPopup(index: number, tabNo: number) {
    const modalRef = this.modalService.open(AttachmentComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
    });
    if (tabNo == 1 && this.Detail.ESS_TaxPreviousEmploymentDetails[index].ESS_EmpTaxInvestmentPrevEmployment_Attachment.length > 0) {
      modalRef.componentInstance.Attachments = this.Detail.ESS_TaxPreviousEmploymentDetails[index].ESS_EmpTaxInvestmentPrevEmployment_Attachment.map(e => ({ 'FileName': e['Attachment'], 'Url': this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ProofAttachment + '/' + e['Attachment'] }));
    } else if (tabNo == 2 && this.SectionDetails[index].Attachments.length > 0) {
      modalRef.componentInstance.Attachments = this.SectionDetails[index].Attachments.map((e: any) => ({ 'FileName': e['Attachment'], 'Url': this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ProofAttachment + '/' + e['Attachment'] }));
    } else if (tabNo == 3 && this.Detail.ESS_EmpTaxDeclarationDetails_HRA[index].ESS_EmpTaxInvestmentDetails_HRAAttachment.length > 0) {
      modalRef.componentInstance.Attachments = this.Detail.ESS_EmpTaxDeclarationDetails_HRA[index].ESS_EmpTaxInvestmentDetails_HRAAttachment.map(e => ({ 'FileName': e['Attachment'], 'Url': this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ProofAttachment + '/' + e['Attachment'] }));
    } else if (tabNo == 4 && this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].ESS_EmpTaxInvestmentDetails_LOPAttachment.length > 0) {
      modalRef.componentInstance.Attachments = this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].ESS_EmpTaxInvestmentDetails_LOPAttachment.map(e => ({ 'FileName': e['Attachment'], 'Url': this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ProofAttachment + '/' + e['Attachment'] }));
    } else if (tabNo == 5 && this.SectionDetailsOther[index].Attachments.length > 0) {
      modalRef.componentInstance.Attachments = this.SectionDetailsOther[index].Attachments.map((e: any) => ({ 'FileName': e['Attachment'], 'Url': this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ProofAttachment + '/' + e['Attachment'] }));
    }

    modalRef.result.then((result: any) => {
      if (tabNo == 1) {
        this.Detail.ESS_TaxPreviousEmploymentDetails[index].ESS_EmpTaxInvestmentPrevEmployment_Attachment = result.map((e: any) => ({ 'Attachment': e.FileName }));
      } else if (tabNo == 2) {
        this.SectionDetails[index].Attachments = result.map((e: any) => ({ 'Attachment': e.FileName }));
      } else if (tabNo == 3) {
        this.Detail.ESS_EmpTaxDeclarationDetails_HRA[index].ESS_EmpTaxInvestmentDetails_HRAAttachment = result.map((e: any) => ({ 'Attachment': e.FileName }));
      } else if (tabNo == 4) {
        this.Detail.ESS_EmpTaxDeclarationDetails_LOP[index].ESS_EmpTaxInvestmentDetails_LOPAttachment = result.map((e: any) => ({ 'Attachment': e.FileName }));
      } else if (tabNo == 5) {
        this.SectionDetailsOther[index].Attachments = result.map((e: any) => ({ 'Attachment': e.FileName }));
      }
    })
  }

  async ESS_EmpTaxInvestment_InsertUpdate() {
    this.isDisabled = true;
    if (this.user.UserType == 'E') {
      this.Detail.EmpMasterId = this.user.UserId;
    }

    if (this.user.UserType == 'A') {
      this.Detail.SelectType = 'insert';
    }

    this.incometax.ESS_EmpTaxInvestment_InsertUpdate(this.SaveDetail).subscribe({
      next: async (response) => {
        if (response.Error_Code == '708' || response.Error_Code == '722') {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            if (this.user.UserType == 'A') {
              this.router.navigate(['/incometax/incometax/detail/e', response.OutputId]);
            } else {
              this.router.navigate(['/request/incometax/taxinvestment/detail', response.OutputId]);
            }
          });
        } else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_EmpTaxInvestmentSelectGet(SelectType: string, IsRegimeSet = false) {
    this.isDisabled = true;
    if (this.user.UserType == 'A') {
      this.Detail.ESS_EmpTaxInvestmentID = this.ESS_EmpTaxInvestmentID;
      this.Detail.EmpMasterId = this.EmpMasterId;
    }
    this.incometax.ESS_EmpTaxInvestmentSelect({ SelectType: SelectType, ESS_EmpTaxInvestmentID: this.Detail.ESS_EmpTaxInvestmentID, EmpMasterId: this.user.UserType == 'A' ? this.Detail.EmpMasterId : this.user.UserId, FinancialYearFrom: SelectType == 'S' ? this.Detail.FinancialYearFrom : '', FinancialYearTo: SelectType == 'S' ? this.Detail.FinancialYearTo : '', IsDraft: this.IsDraft, ApprovalStatus: this.user.UserType == 'A' ? 'Approved' : 'ALL' }).subscribe({
      next: (response) => {
        if (response) {
          if (response.Table && response.Table.length > 0) {
            if (this.user.UserType == 'A') {
              this.Detail.ESS_EmpTaxInvestmentID = 0;
            } else {
              this.Detail.SelectType = 'update';
            }
            //this.Detail.ESS_EmpTaxInvestmentID = response.Table[0].ESS_EmpTaxInvestmentID;
            this.Detail.EmpMasterId = response.Table[0].EmpMasterId;
            if (IsRegimeSet) {
              this.Detail.IsNewRegime = response.Table[0].IsNewRegime;
            }
            this.Detail.FinancialYearFrom = response.Table[0].FinancialYearStart;
            this.Detail.FinancialYearTo = response.Table[0].FinancialYearEnd;

            this.IsDraft = response.Table[0].IsDraft;
            this.isEditAllow = (this.IsDraft || (this.common.ToLowerCase(response.Table[0].ApprovalStatus) == 'approved' && this.Detail.ESS_EmpTaxInvestmentID == 0 && this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == response.Table[0].ESS_TaxFinancialYearID)[0].IsMultipleDeclarationAllowed));
            if (this.Detail.ESS_EmpTaxDeclarationID == 0) {
              this.Detail.SelectType = 'insert';
            }
            this.Detail.ESS_TaxFinancialYearId = response.Table[0].ESS_TaxFinancialYearID;

            if (this.isEditAllow) {
              if (response.Table3) {
                this.Detail.ESS_TaxPreviousEmploymentDetails = response.Table3.map((e: any) => ({ ...e, ESS_EmpTaxInvestmentPrevEmployment_Attachment: [] }));
                if (response.Table4 && response.Table4.length > 0) {
                  if (response.Table4[0].ESS_EmpTaxInvestmentPrevEmploymentDetailsId != null) {
                    this.Detail.ESS_TaxPreviousEmploymentDetails.forEach(element => {
                      element.ESS_EmpTaxInvestmentPrevEmployment_Attachment = response.Table4.filter((e: any) => e.ESS_EmpTaxInvestmentPrevEmploymentDetailsId == element.ESS_TaxPreviousEmploymentDetailsID).map((e: any) => ({ 'Attachment': e.Attachment }));
                    });
                  }
                }
              }

              if (response.Table1) {
                this.Detail.ESS_EmpTaxInvestmentDetails = response.Table1.map((e: any) => ({ ...e, ESS_EmpTaxInvestmentDetails_Attachment: [] }));
                if (response.Table2 && response.Table2.length > 0) {
                  if (response.Table2[0].ESS_EmpTaxInvestmentDetailsId != null) {
                    this.Detail.ESS_EmpTaxInvestmentDetails.forEach(element => {
                      element.ESS_EmpTaxInvestmentDetails_Attachment = response.Table2.filter((e: any) => e.ESS_EmpTaxInvestmentDetailsId == element.ESS_EmpTaxInvestmentDetailsId).map((e: any) => ({ 'Attachment': e.Attachment }));
                    });
                  }
                }
              }

              if (response.Table5) {
                if (response.Table5.length > 0) {
                  this.Detail.IsHouseRented = true;
                }
                this.Detail.ESS_EmpTaxDeclarationDetails_HRA = response.Table5.map((e: any) => ({ ...e, ESS_EmpTaxInvestmentDetails_HRAAttachment: [] }));
                this.Detail.ESS_EmpTaxDeclarationDetails_HRA.forEach(element => {
                  if (element.FromDate != null && element.FromDate != '') {
                    element.FromDate = this.dateFormat.parse(element.FromDate);
                  }
                  if (element.ToDate != null && element.ToDate != '') {
                    element.ToDate = this.dateFormat.parse(element.ToDate);
                  }
                });
                if (response.Table6 && response.Table6.length > 0) {
                  if (response.Table6[0].ESS_EmpTaxInvestmentDetails_HRAId != null) {
                    this.Detail.ESS_EmpTaxDeclarationDetails_HRA.forEach(element => {
                      element.ESS_EmpTaxInvestmentDetails_HRAAttachment = response.Table6.filter((e: any) => e.ESS_EmpTaxInvestmentDetails_HRAId == element.ESS_EmpTaxInvestmentDetails_HRAID).map((e: any) => ({ 'Attachment': e.Attachment }));
                    });
                  }
                }
              }

              if (response.Table9) {
                if (response.Table9.length > 0) {
                  this.Detail.IsLetOutProperty = true;
                }
                this.Detail.ESS_EmpTaxDeclarationDetails_LOP = response.Table9.map((e: any) => ({ ...e, ESS_EmpTaxInvestmentDetails_LOPAttachment: [] }));
                if (response.Table10 && response.Table10.length > 0) {
                  if (response.Table10[0].ESS_EmpTaxInvestmentDetails_LOPId != null) {
                    this.Detail.ESS_EmpTaxDeclarationDetails_LOP.forEach(element => {
                      element.ESS_EmpTaxInvestmentDetails_LOPAttachment = response.Table10.filter((e: any) => e.ESS_EmpTaxInvestmentDetails_LOPId == element.ESS_EmpTaxInvestmentDetails_LOPID).map((e: any) => ({ 'Attachment': e.Attachment }));
                    });
                  }
                }
              }

              if (response.Table7) {
                this.Detail.ESS_EmpTaxDeclarationDetails_Others = response.Table7.map((e: any) => ({ ...e, ESS_EmpTaxInvestmentDetails_OthersAttachment: [] }));
                if (response.Table8 && response.Table8.length > 0) {
                  if (response.Table8[0].ESS_EmpTaxInvestmentDetails_OthersId != null) {
                    this.Detail.ESS_EmpTaxDeclarationDetails_Others.forEach(element => {
                      element.ESS_EmpTaxInvestmentDetails_OthersAttachment = response.Table8.filter((e: any) => e.ESS_EmpTaxInvestmentDetails_OthersId == element.ESS_EmpTaxInvestmentDetails_OthersID).map((e: any) => ({ 'Attachment': e.Attachment }));
                    });
                  }
                }
              }

              if (this.user.UserType == 'A' && this.Detail.EmpMasterId > 0) {
                this.ComboLoad("FilterOnEmpCodeName");
              }

            } else {
              if (this.user.UserType == 'A') {
                this.router.navigate(['/incometax/incometax/detail/e/', response.Table[0].ESS_EmpTaxInvestmentID]);
              } else {
                this.router.navigate(['request/incometax/taxinvestment/detail/', response.Table[0].ESS_EmpTaxInvestmentID]);
              }
            }
          }
          this.TaxSectionMasterSelectLoad();
          this.ComboLoad('IncomeTaxHead');
          this.isLoad = true;

          this.OpenCard = {
            CardPreviousEmployment: true as any,
            CardEmpTaxDeclarationDetails: true as any,
            CardEmpTaxDeclarationDetails_HRA: true as any,
            CardEmpTaxDeclarationDetails_Others: true as any,
            CardEmpTaxDeclarationDetails_LOP: true as any,
          }

          if (
            //this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].IsInvestmentOpen == 0 || 
            !this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].IsDraftInvestmentAllowed
            || (!this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].IsMultipleProofSubmissionAllowed && response.Table[0].ESS_EmpTaxInvestmentID > 0)) {
            this.isEditAllow = false;
            if (this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].IsInvestmentOpen == 0) {
              this.Message = 'The investment has been locked, and Add/Edit is not allowed. kindly contact administrator';
            } else if (!this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].IsDraftInvestmentAllowed) {
              this.Message = 'The investment has been not allowed to draft';
            }
          } else {
            this.isEditAllow = true;
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  onSwitchChange(event: any, cardname: string) {
    if (this.isLoad) {
      if (cardname == "CardPreviousEmployment") {
        this.OpenCard.CardPreviousEmployment = event.target.checked;
      } else if (cardname == "CardEmpTaxDeclarationDetails") {
        this.OpenCard.CardEmpTaxDeclarationDetails = event.target.checked;
      } else if (cardname == "CardEmpTaxDeclarationDetails_HRA") {
        this.OpenCard.CardEmpTaxDeclarationDetails_HRA = event.target.checked;
      } else if (cardname == "CardEmpTaxDeclarationDetails_Others") {
        this.OpenCard.CardEmpTaxDeclarationDetails_Others = event.target.checked;
      } else if (cardname == "CardEmpTaxDeclarationDetails_LOP") {
        this.OpenCard.CardEmpTaxDeclarationDetails_LOP = event.target.checked;
      }
    } else {
      this.OpenCard = {
        CardPreviousEmployment: false as any,
        CardEmpTaxDeclarationDetails: false as any,
        CardEmpTaxDeclarationDetails_HRA: false as any,
        CardEmpTaxDeclarationDetails_Others: false as any,
        CardEmpTaxDeclarationDetails_LOP: false as any,
      }
    }
  }

  ESS_TaxFinancialYearSelect() {
    this.isDisabled = true;
    this.incometax.ESS_TaxFinancialYearSelect({ SelectType: 'S', ESS_TaxFinancialYearID: null, FinancialYearFrom: null, FinancialYearTo: null }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.FinancialYears = response.Table.filter((e: any) => e.IsActive);
          this.FinancialYears.forEach(element => {
            element.FinancialYear = new Date(element.FinancialYearStart).getFullYear() + ' - ' + new Date(element.FinancialYearEnd).getFullYear();
          });
        } else {
          this.FinancialYears = [];
        }
        this.isDisabled = false;
      },
      complete: () => {
        if (this.Detail.ESS_EmpTaxInvestmentID > 0) {
          this.ESS_EmpTaxInvestmentSelectGet('E', true);
        }
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  changeFinancialYear(): string | null {
    if (!this.Detail?.ESS_TaxFinancialYearId) return null;

    const financialYear = this.FinancialYears.find(
      e => e.ESS_TaxFinancialYearID === this.Detail.ESS_TaxFinancialYearId
    );

    return financialYear?.LastDateForProofSubmission || null;
  }

  setRegime() {
    if (this.Detail.ESS_TaxFinancialYearId != null && this.Detail.ESS_TaxFinancialYearId > 0) {
      this.Detail.IsNewRegime = this.common.ToLowerCase(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearId)[0].DefaultRegimeSelection) == 'n';
    }
  }
}

